import { useState } from 'react';

//Types
import { InspireReport } from 'Shared/types/InspireReport.types';

//Api
import { fetchReport } from 'Shared/api/PiInspire.api';

//Hooks
import { useOrganization } from './use-organization';

type Props = {
  surveyUserGuid: string;
};

export const useInspireReports = ({ surveyUserGuid }: Props) => {
  const { organization, isPiDemoAccount } = useOrganization();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getInspireReport = async (reportType: InspireReport) => {
    try {
      if (isPiDemoAccount || !surveyUserGuid) {
        return;
      }
      if (organization.pi_company_guid) {
        const response = await fetchReport({
          companyGuid: organization.pi_company_guid,
          surveyuserGuid: surveyUserGuid,
          reportType,
        });
        if (response.status != 200) {
          throw new Error('Network response was not ok for Inspire Api');
        }

        const blob = await response.data;
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
      }
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  return { error, loading, getInspireReport };
};
